import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import { useAuthStore } from '@/stores/authStore'

// Bootstrap auth state before the first render so ProtectedRoute can
// resolve immediately (no flash of /login when the user already has a
// valid session).
useAuthStore.getState().initializeSession()

// Register the service worker so the app is installable to home screen
// / desktop. The SW itself is a pure passthrough (see public/sw.js) —
// it exists only to satisfy browser installability requirements.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
